import { render, staticRenderFns } from "./manage-studio.vue?vue&type=template&id=e2bfe862&"
import script from "./manage-studio.vue?vue&type=script&lang=js&"
export * from "./manage-studio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports